import { SNoop } from '@obvious.tech/util/validation/schemas'
import { defineEntity } from '../../defineEntity'
import { IUserTaskList } from '@obvious.tech/constellation'

export const UserTaskList = defineEntity('UserTaskList', {
  endpoint: 'tasks/api/UserTaskList',
  schema: SNoop<IUserTaskList>(),
})
